import React from "react";
import { Radio } from "antd";
import classNames from "classnames";

// interfaces
import { RadioGroupProps } from "./IRadioGroup";

//components
import LabelErrorProvider from "../../components/LabelErrorProvider";

//assets
import styles from "../../assets/styles/shared/radio-group.module.scss";

const RadioGroup = (props: RadioGroupProps) => {
  const {
    options = [],
    onChange,
    value,
    label,
    error,
    className,
    wrapperClassName,
    ...restProps
  } = props;

  const radioGroupClassName = classNames(styles["locl-radio-group"], className);

  return (
    <LabelErrorProvider error={error} label={label} className={wrapperClassName}>
      <Radio.Group onChange={onChange} value={value} className={radioGroupClassName} {...restProps}>
        {options.map((option, index) => (
          <Radio key={`${option.value}-${index}`} value={option.value} checked={true}>
            {option.label}
          </Radio>
        ))}
      </Radio.Group>
    </LabelErrorProvider>
  );
};

export default RadioGroup;
